class CartNotification extends HTMLElement {
  constructor() {
    super();

    this.notification = document.getElementById('cart-notification');
    this.header = document.querySelector('sticky-header');
    this.onBodyClick = this.handleBodyClick.bind(this);
    
    this.notification.addEventListener('keyup', (evt) => evt.code === 'Escape' && this.close());
    this.querySelectorAll('button[type="button"]').forEach((closeButton) =>
      closeButton.addEventListener('click', this.close.bind(this))
    );
  }

  open() {
    this.notification.classList.add('animate', 'active');

    this.notification.addEventListener('transitionend', () => {
      this.notification.focus();
      trapFocus(this.notification);
    }, { once: true });

    document.body.addEventListener('click', this.onBodyClick);

	this.showFreeShippingInfoOnLoad();
  }

  close() {
    this.notification.classList.remove('active');

    document.body.removeEventListener('click', this.onBodyClick);

    removeTrapFocus(this.activeElement);
  }

  renderContents(parsedState) {
      this.productId = parsedState.id;
      this.getSectionsToRender().forEach((section => {
        document.getElementById(section.id).innerHTML =
          this.getSectionInnerHTML(parsedState.sections[section.id], section.selector);
      }));

      if (this.header) this.header.reveal();
      this.open();
  }

  getSectionsToRender() {
    return [
      {
        id: 'cart-notification-product',
        selector: `#cart-notification-product-${this.productId}`,
      },
      {
        id: 'cart-notification-button'
      },
      {
        id: 'cart-icon-bubble'
      }
    ];
  }

  getSectionInnerHTML(html, selector = '.shopify-section') {
    return new DOMParser()
      .parseFromString(html, 'text/html')
      .querySelector(selector).innerHTML;
  }

  handleBodyClick(evt) {
    const target = evt.target;
    if (target !== this.notification && !target.closest('cart-notification')) {
      const disclosure = target.closest('details-disclosure');
      this.activeElement = disclosure ? disclosure.querySelector('summary') : null;
      this.close();
    }
  }

  setActiveElement(element) {
    this.activeElement = element;
  }

  // FREE SHIPPING MESSAGE START
  calculateFreeShipping(currency, total) {
    console.log(currency);
    var limits = {
      "USD": [8000,  "$"],
      "GBP": [6000,  "£"],
      "EUR": [7000,  "€"],
      "CAD": [10000, "$"],
	  "AUD": [11000, "$"],
	};
    const freeLimit = limits[currency] || limits["CAD"];
    const remainder = (freeLimit[0] - total) / 100;
    console.log(remainder);
    if (remainder > 0) {
      document.querySelector(".shipping-savings-message-notification").innerHTML = `You are <b>${freeLimit[1]}${remainder}</b> away from free shipping!`
    } else {
	  document.querySelector(".shipping-savings-message-notification").innerHTML = `You've got free shipping!`
    }
  }

  showFreeShippingInfoOnLoad() {
    fetch(`/cart.js`)
      .then((response) => {
        return response.text();
      })
      .then((state) => {
        const parsedState = JSON.parse(state);

        console.log(parsedState);
        this.calculateFreeShipping(parsedState.currency, parsedState.total_price);
      });
  }
  // FREE SHIPPING MESSAGE END

}

customElements.define('cart-notification', CartNotification);
